import React, { useCallback } from 'react'
import { useSelector } from 'react-redux'
import MerchandiseContainer from './MerchandiseContainer'
import AccordionInvoice from '@commonComponents/accordion/AccordianInvoice'

const Merchandise = (props) => {
  const { invoiceId, invoiceIndex, isInvoiceDisabled } = props
  const dataSource = useSelector(
    (state) => state.invoiceReducer.invoice.invoiceMap[invoiceId].merchandiseIdList
  )
  // const renderItem = useCallback(
  //   (merchandiseId, index) => (
  //     <MerchandiseContainer invoiceId={invoiceId} merchandiseId={merchandiseId} itemIndex = {index} />
  //   ),
  //   [dataSource, invoiceId]
  // )

  return (
    <>
      {dataSource?.length > 0 &&
        <AccordionInvoice
          initialiState={{}}
          keyName={"toggleLineItems"}
          invoiceId={invoiceId}
          expandTitle={"OPEN_ALL_ITEMS"}
          collapseTitle={"CLOSE_ALL_ITEMS"}
        >
          {dataSource.map((merchandiseId, index) => (
            <MerchandiseContainer
              id={merchandiseId}
              key={merchandiseId}
              invoiceId={invoiceId}
              invoiceIndex={invoiceIndex}
              merchandiseId={merchandiseId}
              itemIndex={index}
              isInvoiceDisabled={isInvoiceDisabled}
            />
          ))}
        </AccordionInvoice>}
    </>
  )
}

export default React.memo(Merchandise)
